<script setup lang="ts">
	interface FileInputProps {
		item: {
			url: string;
			file: File;
		};
	}

	const props = defineProps<FileInputProps>();
	const emits = defineEmits(['delete']);

	const isImage = computed(() => props.item.file.type.includes('image'));
	const isPdf = computed(() => props.item.file.type.includes('pdf'));
	const isMp4 = computed(() => props.item.file.type.includes('mp4'));
</script>

<template>
	<li class="item">
		<div class="item__left">
			<img v-if="isImage" class="item__left--img" :src="item.url" :alt="item.file.name" />
			<Icon v-else-if="isPdf" class="item__left--img" name="local:file-pdf" />
			<Icon v-else-if="isMp4" class="item__left--img" name="local:file-mp4" />
			<Icon v-else class="item__left--img" name="local:file-doc" />
			<p class="item__left--text">{{ item.file.name.slice(0, 80) }}</p>
		</div>

		<div class="item__right">
			<a class="item__right--show" :href="item.url" target="_blank">
				<Icon name="local:eye" />
			</a>
			<Icon
				name="local:close"
				class="item__right--delete"
				@click="
					() => {
						emits('delete');
					}
				"
			/>
		</div>
	</li>
</template>

<style scoped lang="scss">
	.item {
		padding: 0.5rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		transition: background-color 0.3s ease-in-out;
		&:hover {
			background: var(--color-grey);
		}
		&__left {
			display: flex;
			align-items: center;
			gap: 0.75rem;

			&--img {
				width: 1.5rem;
				height: 1.5rem;
				object-fit: contain;
				border-radius: 20px;
			}

			&--text {
				font-size: 0.625rem;
			}
		}

		&__right {
			display: flex;
			gap: 1rem;
			&--show {
				svg {
					color: var(--color-grey-dark);
					width: 1.5rem;
					height: 1.5rem;
					transition: color 0.3s ease-in-out;

					&:hover {
						color: var(--color-black);
					}
				}
			}

			&--delete {
				width: 1.5rem;
				height: 1.5rem;
				color: var(--color-grey-dark);
				cursor: pointer;
				transition: color 0.3s ease-in-out;

				&:hover {
					color: var(--color-black);
				}
			}
			&--show,
			&--delete {
				color: var(--color-grey);
			}
		}
	}

	@media screen and (min-width: 768px) {
		.item {
			&__left {
				&--img {
					width: 2rem;
					height: 2rem;
				}

				&--text {
					font-size: 0.75rem;
				}
			}
		}
	}

	@media screen and (min-width: 1440px) {
		.item {
			&__left {
				&--img {
					width: 3.25rem;
					height: 3.25rem;
				}

				&--text {
					font-size: 1rem;
				}
			}
		}
	}
</style>
